import province_city_area from '@form-create/data/dist/province_city_area.js'
import { mapGetters } from 'vuex'
import { uploadImage, uploadQiNiu } from '@/api/upload'

province_city_area.push({ label: '港澳台', value: '港澳台' })

export default {
    components: {},
    data() {
        return {
            upload_url: process.env.VUE_APP_BASE_API + '/upload/image'
        }
    },

    computed: {
        ...mapGetters(['token'])
    },

    created() {},

    methods: {
        resetCascaderOptions(setting) {
            setting.forEach((item) => {
                if (item.type === 'cascader') {
                    item.props.options = []
                }
            })
            return setting
        },

        addCascaderOptions(setting, list = []) {
            setting.forEach((item) => {
                if (item.type === 'cascader') {
                    item.apiList ? (item.props.options = list) : (item.props.options = province_city_area)
                }
            })
            return setting
        },

        getValidatorCallBackNew(field, fApi) {
            const validate = []
            switch (field) {
                // 当前选择的是身份证类型
                case 'card_type':
                    // 选择的值是“身份证”的话 根据身份证正则校验
                    if (fApi.form[field] === '身份证') {
                        validate.push({
                            additional: true,
                            type: 'string',
                            required: true,
                            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
                            message: '请输入正确的证件号',
                            trigger: 'blur'
                        })
                    }
                    break
                case 'mobile':
                    // validate = {
                    //     reg: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                    //     message: '请输入正确的手机号'
                    // }
                    break

                case 'email':
                    // validate = {
                    //     reg: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
                    //     message: '请输入正确的邮箱'
                    // }
                    break

                case 'card':
                    // validate = {
                    //     reg: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
                    //     message: '请输入正确的证件号'
                    // }
                    break

                default:
                    break
            }
            // let validate = {
            //     reg: '',
            //     message: ''
            // }
            // switch (field) {
            //     case 'mobile':
            //         validate = {
            //             reg: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            //             message: '请输入正确的手机号'
            //         }
            //         break

            //     case 'email':
            //         validate = {
            //             reg: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            //             message: '请输入正确的邮箱'
            //         }
            //         break

            //     case 'card':
            //         validate = {
            //             reg: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            //             message: '请输入正确的证件号'
            //         }
            //         break

            //     default:
            //         break
            // }
            return validate
        },

        resetFormRules(rules, info = {}, selectList = []) {
            // 格式化 人员信息、作品信息表单规则(渲染form表单需要)
            const newRules = rules.map((item) => {
                // 上传
                if (item.type === 'upload') {
                    // item.field === 'thumb_ids' ? item.props.limit = 1 : ''
                    item.props.action = this.upload_url
                    const uploadType = item.props.uploadType // 设置的上传的文件类型
                    // 自定义上传
                    item.props.httpRequest = (res) => {
                        const isLt200M = res.file.size / 1024 / 1024 < 200
                        const fileType = res.file.type // 当前文件类型
                        const uploadAPI = item.uploadAPI // 上传的途径（决定哪个接口）
                        if (!isLt200M) {
                            return false
                        }
                        if (fileType.indexOf(uploadType) === -1 && uploadType === 'image') {
                            return false
                        }
                        // 文件二进制流需要formdata
                        const formdata = new FormData()
                        formdata.append('iFile', res.file)
                        // 上传本地 或 上传七牛
                        const UploadAPI = !uploadAPI || uploadAPI === 'default' ? uploadImage : uploadQiNiu
                        if (!uploadAPI || uploadAPI === 'default') {
                            UploadAPI(formdata).then((uploadRes) => {
                                if (uploadRes.code === 422) {
                                    this.$message.warning(uploadRes.message)
                                    return
                                }
                                if (uploadRes.code !== 200) return
                                // 执行上传成功钩子函数 实现赋值
                                res.onSuccess(uploadRes.data.file_path)
                            })
                        } else {
                            uploadQiNiu().then((qn) => {
                                const { bucket, domain, host_url, token } = qn.data
                                const keyname =
                                    bucket +
                                    new Date().getTime() +
                                    Math.floor(Math.random() * 100) +
                                    '.' +
                                    res.file.name.substring(res.file.name.lastIndexOf('.') + 1)
                                const formdata = new FormData()
                                formdata.append('file', res.file)
                                formdata.append('token', token)
                                formdata.append('key', keyname)
                                const config = {
                                    headers: { 'Content-Type': 'multipart/form-data' }
                                }
                                this.$axios.post(host_url, formdata, config).then((qiniuRes) => {
                                    if (qiniuRes.status !== 200) return
                                    res.onSuccess(domain + '/' + qiniuRes.data.key)
                                })
                            })
                        }
                    }
                    // 文件上传时
                    item.props.onChange = (file) => {
                        // 判断上传类型
                        const isLt200M = file.size / 1024 / 1024 < 200
                        const fileType = file.raw.type // 当前文件类型
                        if (!isLt200M) {
                            this.$message.error('上传图片大小不能超过200MB!')
                            return false
                        }
                        if (fileType.indexOf(uploadType) === -1 && uploadType === 'image') {
                            this.$message.warning('上传文件格式有误')
                            return false
                        }
                        // 上传中等待
                        if (file.status === 'ready') {
                            file.percentage = 0
                            const timer = setInterval(() => {
                                if (file.percentage > 80) {
                                    file.percentage = 81
                                    clearInterval(timer)
                                    return
                                }
                                file.percentage += 1
                            }, 20)
                        }
                        if (file.status === 'success') {
                            file.percentage = 100
                        }
                    }
                    // 上传成功
                    item.props.onSuccess = (file_path, file) => {
                        file.url = file_path
                    }
                }
                // 级联 嵌入地区或普通数据
                if (item.type === 'cascader') {
                    item.apiList ? (item.props.options = selectList) : (item.props.options = province_city_area)
                }
                // 表单验证
                // const valid = this.getValidatorCallBackNew(item.valid_field)
                // valid.reg ? item.validate.push({ type: 'string', required: true, pattern: valid.reg, message: valid.message, trigger: 'blur' }) : item.validate
                // // 是否隐藏
                // let hidden = ''
                // if (item.props.showLogicField) {
                //     hidden = {
                //         type: 'hidden',
                //         field: item.field
                //     }
                // }
                // 返回对象
                return {
                    field: item.field,
                    props: item.props,
                    options: item.options ? item.options : [],
                    title: item.title,
                    type: item.type,
                    valid_field: item.valid_field, // 需要校验字段
                    validate: item.validate,
                    value: info[item.field] || item.value, // Object.keys(info).length > 0 && info[item.field] ? info[item.field] : item.value,
                    tableShow: item.tableShow, // 是否在类表中展示字段
                    apiList: item.apiList, // 判断cascader是自定义多层级还是地区
                    // hidden,
                    emit: ['change'],
                    on: {
                        change: (e) => {
                            // radio 控制其他标签显示或者隐藏
                            // const index = newRules.findIndex(nitem => nitem.field === item.props.effectShowField)
                            // if (index === -1) return
                            // if (e !== item.props.effectShowVal) {
                            //     this.$set(newRules[index], 'hidden', {
                            //         type: 'hidden',
                            //         field: newRules[index].field
                            //     })
                            // } else {
                            //     this.$delete(newRules[index], 'hidden')
                            // }
                        }
                    }
                }
            })
            return newRules
        }
    }
}
